import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import VueI18n from "vue-i18n";
import messages from "./translations.json";
import VueCurrencyInput from "vue-currency-input";
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VueNumericInput from 'vue-numeric-input';
import { apiBaseURL } from "./config/api";
require("./plugins");

Vue.config.productionTip = false;
Vue.prototype.$apiRoute = apiBaseURL;

const pluginOptions = {
  /* see config reference */
};

Vue.use(VueNumericInput);
Vue.use(VueCurrencyInput, pluginOptions);
Vue.use(VueI18n);
Vue.use(VuejsDialog, {
  okText: 'Si',
  cancelText: 'No',
});

let messagesVar = messages;
const i18n = new VueI18n({
  locale: "es", // set locale
  fallbackLocale: "es",
  silentFallbackWarn: true,
  messages: messagesVar // set locale messages
});

Vue.use(Vuetify, {
  theme: {
    primary: "#0C2747"
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

//Color Navi #0C2747

export { i18n };
